import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { RUPTURE_TYPE } from 'constants/config'
import Mask from 'vanilla-masker'

class RuptureViewContent extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    titleText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    valueComplement: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    titleList: PropTypes.string.isRequired,
    listSections: PropTypes.array.isRequired,
    typeContent: PropTypes.number.isRequired,
  }

  state = {
    percent: '',
    currency: '',
    sizeCurrency: '',
    formatCurrency: {
      separator: '',
      delimiter: '',
    },
  }

  componentDidMount() {
    const { translate } = this.props

    this.setState({
      percent: translate('option.percent'),
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    })
  }

  renderSector = (sector, index) => {
    const { typeContent } = this.props

    let { quantity } = sector
    if (typeContent === RUPTURE_TYPE.SALES) {
      quantity =
        this.state.currency +
        Mask.toMoney(
          quantity.toFixed(this.state.sizeCurrency),
          this.state.formatCurrency
        )
    }

    let percent = sector.percent || 0
    percent =
      Mask.toMoney(
        percent.toFixed(this.state.sizeCurrency),
        this.state.formatCurrency
      ) + this.state.percent

    return (
      <tr key={index}>
        <td>{`${sector.cd ? `${sector.cd} - ` : ''}${sector.ds || ''}`}</td>
        <td className='align-right'>{quantity}</td>
        <td className='align-right'>{percent}</td>
      </tr>
    )
  }

  render() {
    const {
      icon,
      titleText,
      value,
      valueComplement,
      subtitle,
      titleList,
      listSections,
      translate,
      typeContent,
    } = this.props

    let dataLabel = ''
    let valueLabel = ''

    switch (typeContent) {
      case RUPTURE_TYPE.TOTAL:
        dataLabel = translate('ruptures.top')
        valueLabel = translate('ruptures.lmQuantity')
        break
      case RUPTURE_TYPE.TOP2500:
      case RUPTURE_TYPE.LMS:
        dataLabel = translate('ruptures.section')
        valueLabel = translate('ruptures.lmQuantity')
        break
      case RUPTURE_TYPE.SALES:
        dataLabel = translate('ruptures.section')
        valueLabel = translate('ruptures.estimatedLoss').replace(
          '{0}',
          this.state.currency
        )
        break
      default:
        break
    }

    return (
      <div className='rectangle rounded'>
        <div className='circular wrap'>
          <i className={icon} />
        </div>

        <h4 className='heading-4 uppercase title'>{titleText}</h4>
        <div>
          <span className='highlighted-number'>{value}</span>
          <span className='subtext'>{valueComplement}</span>
          <br />
        </div>
        <p className='text'>{subtitle}</p>
        <p className='text bold'>{titleList}</p>

        <table className='table table-striped'>
          <thead>
            <tr>
              <th>{dataLabel}</th>
              <th className='align-right'>{valueLabel}</th>
              <th className='align-right'>{this.state.percent}</th>
            </tr>
          </thead>
          <tbody>{listSections.map(this.renderSector)}</tbody>
        </table>
      </div>
    )
  }
}

export default RuptureViewContent

export { RuptureViewContent }
